import { render, staticRenderFns } from "./Foter.vue?vue&type=template&id=0f00a4e0&scoped=true"
import script from "./Foter.vue?vue&type=script&lang=js"
export * from "./Foter.vue?vue&type=script&lang=js"
import style0 from "./Foter.vue?vue&type=style&index=0&id=0f00a4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00a4e0",
  null
  
)

export default component.exports